import { RegisterProvisionalCompanyUserMutation } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const registerProvisionalCompanyUserHandler =
  graphql.mutation<RegisterProvisionalCompanyUserMutation>(
    "registerProvisionalCompanyUser",
    ({ query, variables }) => {
      return HttpResponse.json({
        data: {
          registerProvisionalCompanyUser: true,
        },
      });
    }
  );
